import i18n from "../../i18n";

export const SOURCE_SYSTEM_TYPE_OPTIONS = [
  { value: "PHONE", label: "Phone", icon: "phone", i18nKey: "options.contactType.PHONE" },
  { value: "MOBILE", label: "Mobile", icon: "smartphone", i18nKey: "options.contactType.MOBILE" },
  { value: "EMAIL", label: "Email", icon: "email", i18nKey: "options.contactType.EMAIL" },
  { value: "OTHER", label: "Other", icon: "more_horiz", i18nKey: "options.contactType.OTHER" },
  { value: "SIEM", label: "SIEM", icon: "security", i18nKey: "options.contactType.SIEM" },
  { value: "BACKUP", label: "BACKUP", icon: "backup", i18nKey: "options.contactType.BACKUP" },
  { value: "FIREWALL", label: "FIREWALL", icon: "local_fire_department", i18nKey: "options.contactType.FIREWALL" },
  { value: "EPP", label: "EPP", icon: "shield", i18nKey: "options.contactType.EPP" },
  { value: "XDR", label: "XDR", icon: "radar", i18nKey: "options.contactType.XDR" },
  { value: "DLP", label: "DLP", icon: "lock", i18nKey: "options.contactType.DLP" },
  { value: "ISP", label: "ISP", icon: "router", i18nKey: "options.contactType.ISP" },
  { value: "FILE_AUDIT", label: "FILE_AUDIT", icon: "folder_open", i18nKey: "options.contactType.FILE_AUDIT" },
  { value: "MONITORING_TOOL", label: "MONITORING_TOOL", icon: "monitor_heart", i18nKey: "options.contactType.MONITORING_TOOL" },
] as const;

export const ACTIVITY_PERIOD_OPTIONS = [
  { value: "Deviation", label: "Deviation", icon: "show_chart", i18nKey: "options.activityPeriod.Deviation" },
  { value: "Last 30min", label: "Last 30min", icon: "timer", i18nKey: "options.activityPeriod.Last 30min" },
  { value: "Last hour", label: "Last hour", icon: "schedule", i18nKey: "options.activityPeriod.Last hour" },
  { value: "Last day", label: "Last day", icon: "today", i18nKey: "options.activityPeriod.Last day" },
  { value: "Last week", label: "Last week", icon: "date_range", i18nKey: "options.activityPeriod.Last week" },
  { value: "Custom", label: "Custom", icon: "tune", i18nKey: "options.activityPeriod.Custom" },
] as const;

export const MEASUREMENT_TYPE_OPTIONS = [
  { value: "Second", label: "Second", icon: "timer", i18nKey: "options.measurementType.Second" },
  { value: "Minute", label: "Minute", icon: "timelapse", i18nKey: "options.measurementType.Minute" },
  { value: "Hour", label: "Hour", icon: "schedule", i18nKey: "options.measurementType.Hour" },
  { value: "Day", label: "Day", icon: "today", i18nKey: "options.measurementType.Day" },
  { value: "Week", label: "Week", icon: "date_range", i18nKey: "options.measurementType.Week" },
  { value: "Month", label: "Month", icon: "calendar_month", i18nKey: "options.measurementType.Month" },
  { value: "Year", label: "Year", icon: "event_repeat", i18nKey: "options.measurementType.Year" },
] as const;

export const THRESHOLD_TYPE_OPTIONS = [
  { value: "percent", label: "Percent", icon: "percent", i18nKey: "options.thresholdType.percent" },
  { value: "quantity", label: "Quantity", icon: "pin", i18nKey: "options.thresholdType.quantity" },
] as const;

export const DEFAULT_SEVERITY_OPTIONS = [
  { value: "Critical", label: "Critical", icon: "error", i18nKey: "options.severity.Critical" },
  { value: "High", label: "High", icon: "priority_high", i18nKey: "options.severity.High" },
  { value: "Medium", label: "Medium", icon: "remove", i18nKey: "options.severity.Medium" },
  { value: "Low", label: "Low", icon: "south", i18nKey: "options.severity.Low" },
  { value: "Informational", label: "Informational", icon: "info", i18nKey: "options.severity.Informational" },
] as const;

export const ANOMALY_EVENT_SEARCH_FIELDS = [
  "category",
  "subCategory",
  "definition",
  "sourceSystemType",
  "defaultSeverity",
];

export const parseStringListField = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === "string").map((entry) => entry.trim()).filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return [];
    }

    try {
      const parsed = JSON.parse(trimmed);
      return parseStringListField(parsed);
    } catch {
      return [trimmed];
    }
  }

  return [];
};

export const validateCustomActivityPeriod = (formJson: Record<string, string>) => {
  if (formJson.activityPeriod !== "Custom") {
    return null;
  }

  const measurementType = formJson.measurementType?.trim();
  const measurementValue = formJson.measurementValue?.trim();

  if (!measurementType || !measurementValue) {
    return i18n.t("anomalies.validation.customMeasurementRequired");
  }

  const parsedValue = parseInt(measurementValue, 10);
  if (!Number.isInteger(parsedValue) || parsedValue < 1) {
    return i18n.t("anomalies.validation.measurementPositive");
  }

  const validTypes = MEASUREMENT_TYPE_OPTIONS.map((option) => option.value);
  if (!validTypes.some((type) => type === measurementType)) {
    return i18n.t("anomalies.validation.measurementTypeInvalid");
  }

  return null;
};
